import { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Outlet, useParams } from 'react-router-dom';
import { useStore } from '@/stores';
import { Loading } from '@linktivity/link-ui';

const DetailLayout = observer(() => {
  const { paymentDetail } = useStore();
  const { tenantId, paymentId } = useParams();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    paymentDetail
      .getDetail(tenantId as string, paymentId as string)
      .finally(() => setLoading(false));
  }, [paymentDetail, tenantId, paymentId]);

  return loading ? (
    <div className="loading">
      <Loading />
    </div>
  ) : (
    <Outlet />
  );
});

export default DetailLayout;
